// extracted by mini-css-extract-plugin
export default {"container":"appLayout_container__TqVhc","content":"appLayout_content__k3HwC","contentCollapsed":"appLayout_contentCollapsed__vcBIx"};